export default __webpack_public_path__ + "static/media/definix-black-logo.4940d8d4.png";